import type { StorageInterface } from './storage.interface'

export class SessionStorageRepository implements StorageInterface {
  set(key: string, value: string): void {
    sessionStorage.setItem(key, value)
  }

  get(key: string): string | null {
    return sessionStorage.getItem(key)
  }

  remove(key: string): void {
    sessionStorage.removeItem(key)
  }

  clear(): void {
    sessionStorage.clear()
  }
}
